import React from 'react';
import {OrbitComponentWithState} from '../../../base-components/orbit-component-with-state/orbit-component-with-state';
import {ContainerBox} from "./boxes/container.box";
import {FilterByBox} from "./boxes/filter-by.box";
import {FilterCategoryComponent} from '../filter-category/filter-category.component';
import {IAdvancedStrategyFiltersEditorViewModel} from '../../../../services/games-filter/strategies/advanced-filter/advanced-strategy-filters-editor-view-model.interface';
import {IArenaGameFiltersCategoryEditorViewModel} from '../../../../services/games-filter/arena-filters/categories/arena-game-filters-category-editor-view-model.interface';
import {observer} from 'mobx-react';

export interface IFilterCategoriesListComponentProps {
    filtersEditor: IAdvancedStrategyFiltersEditorViewModel;
}

interface IFilterCategoriesListComponentState {
    openFilterCategory: IArenaGameFiltersCategoryEditorViewModel | null;
}

@observer
export class FilterCategoriesListComponent extends OrbitComponentWithState<IFilterCategoriesListComponentProps, IFilterCategoriesListComponentState> {

    state: IFilterCategoriesListComponentState = {
        openFilterCategory: null
    }

    _onCategoryToggled = (category: IArenaGameFiltersCategoryEditorViewModel) => {
        let openFilterCategoryState = this.state.openFilterCategory;

        // if user clicked on new category emulate close current category first
        if (openFilterCategoryState && category.id !== openFilterCategoryState.id) {
            openFilterCategoryState = null;
        }

        this.setState({openFilterCategory: openFilterCategoryState ? null : category});
    }


    render() {
        return (
            <ContainerBox>
                <FilterByBox>Filter By</FilterByBox>

                {this.props.filtersEditor.visibleCategories.map(category => {
                    const isOpen = this.state.openFilterCategory?.id === category.id;

                    return <FilterCategoryComponent
                        key={category.title}
                        category={category}
                        onCategoryToggled={this._onCategoryToggled}
                        isOpen={isOpen}
                    />
                })}
            </ContainerBox>
        )
    }
}